module.exports = __webpack_public_path__ + "img/gray-trash.ad4f9582.svg";